const authConfig = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN.toString(),
    clientId:process.env.REACT_APP_AUTH0_CLIENT_ID.toString(),
    authorizationParams:{
    redirect_uri:`${window.location.origin}/callback`,
    audience: process.env.REACT_APP_AUDIENCE,
    scope: 'openid profile email offline_access',
    organization: process.env.REACT_APP_ORGANIZATION_NAME || undefined,
    },
    useRefreshTokens:true,
    cacheLocation:"memory",  
}

export default authConfig;